import Const from './Constants';

class Calculate {

  static FuncAdd = 'PLUS';
  static FuncMinus = 'MINUS';
  static FuncMultiply = 'MULTIPLY';
  static FuncDivide = 'DIVIDE';
  static FuncSum = 'SUM';
  static FuncRound = 'ROUND';
  static FuncIf = 'IF';
  static FuncGreaterThan = 'GT';

  static isInt = val => {
    var intRegex = /^-?\d+$/;
    return intRegex.test(val);
  }

  static isFloat = val => {
    var intRegex = /^-?\d+[.]\d+$/;
    return intRegex.test(val);
  }

  static calculate = (fields, i, model, calculus) => {
    try {
      if(Calculate.isInt(calculus)) {
        return parseFloat(calculus ? calculus : 0);
      } else if(Calculate.isFloat(calculus)) {
        return parseFloat(calculus ? calculus : 0);
      } else if(!calculus.includes('(')) {
        calculus = String(calculus).trim();

        let field = fields[calculus];
        if(!field && calculus.split('~').length === 3) {
          field = fields[calculus.substring(0, calculus.lastIndexOf('~'))];
        }
        
        let type = field.field_type;
        const tmp = calculus.split('~');
        let val = 0;
        if(tmp[0] === Const.T_Product) {
          if(type === Const.Decimal || type === Const.Number) {
            val = model.products[i][tmp[1]];
          } else if(type === Const.Tax) {
            val = !model.products[i][tmp[1]][Const.TypeInc] ? model.products[i][tmp[1]][tmp[2]] : 0;
          } else if(type === Const.Discount || type === Const.Commission) {
            val = model.products[i][tmp[1]][tmp[2]] ? model.products[i][tmp[1]][tmp[2]] : 0;
          } else {
            val = 0;
          }
        } else {
          val = model[calculus];
        }
        return parseFloat(val ? val : 0);
      } else {
        const startIndx = calculus.indexOf('(');
        let endIndx = startIndx + 1;
        let count = 1;
        while(endIndx < calculus.length && count !== 0) {
          if(calculus.charAt(endIndx) === '(') { count++; }
          if(calculus.charAt(endIndx) === ')') { count--; }
          endIndx++;
        }
        const functionName = calculus.substring(0, startIndx).trim();
        const nextCalculus = calculus.substring(startIndx + 1, endIndx - 1).trim();
        if(functionName === Calculate.FuncAdd) {
          return Calculate.Add(fields, i, model, nextCalculus);
        } else if(functionName === Calculate.FuncMinus) {
          return Calculate.Minus(fields, i, model, nextCalculus);
        } else if(functionName === Calculate.FuncMultiply) {
          return Calculate.Multiply(fields, i, model, nextCalculus);
        } else if(functionName === Calculate.FuncDivide) {
          return Calculate.Divide(fields, i, model, nextCalculus);
        } else if(functionName === Calculate.FuncSum) {
          return Calculate.Sum(fields, i, model, nextCalculus);
        } else if(functionName === Calculate.FuncRound) {
          return Calculate.Round(fields, i, model, nextCalculus);
        } else if(functionName === Calculate.FuncIf) {
          return Calculate.If(fields, i, model, nextCalculus);
        } else if(functionName === Calculate.FuncGreaterThan) {
          return Calculate.GreaterThan(fields, i, model, nextCalculus);
        }
      }
    } catch(err) {
      console.log(err);
    }
    return 0;
  }

  static Add = (fields, i, model, calculus) => {
    const tmp = Calculate.EuationSeperator(calculus);
    let add = Calculate.calculate(fields, i, model, tmp[0]);
    for(let j = 1; j < tmp.length; j++) {
      add = add + Calculate.calculate(fields, i, model, tmp[j]);
    }
    return add;
  }

  static Minus = (fields, i, model, calculus) => {
    const tmp = Calculate.EuationSeperator(calculus);
    let minus = Calculate.calculate(fields, i, model, tmp[0]);
    for(let j = 1; j < tmp.length; j++) {
      minus = minus - Calculate.calculate(fields, i, model, tmp[j]);
    }
    return minus;
  }

  static Multiply = (fields, i, model, calculus) => {
    const tmp = Calculate.EuationSeperator(calculus);
    let multiply = Calculate.calculate(fields, i, model, tmp[0]);
    for(let j = 1; j < tmp.length; j++) {
      multiply = multiply * Calculate.calculate(fields, i, model, tmp[j]);
    }
    return multiply;
  }

  static Divide = (fields, i, model, calculus) => {
    const tmp = Calculate.EuationSeperator(calculus);
    let divide = Calculate.calculate(fields, i, model, tmp[0]);
    for(let j = 1; j < tmp.length; j++) {
      const tmp1 = Calculate.calculate(fields, i, model, tmp[j])
      divide = tmp1 ? divide / tmp1 : 0;
    }
    return divide;
  }

  static Sum = (fields, i, model, calculus) => {
    let sum = 0;
    if(calculus.includes(Const.T_Product) && calculus.includes(Const.Opt)) {
      for(let j = 0; j < model.products.length; j++) {
        const value = Calculate.calculate(fields, j, model, calculus);
        sum = sum || sum !== 0 ? sum + value : value;
      }
    } else {
      const value = Calculate.calculate(fields, i, model, calculus);
      sum = sum || sum !== 0 ? sum + value : value;
    }
    return sum;
  }

  static Round = (fields, i, model, calculus) => {
    const tmp = Calculate.EuationSeperator(calculus);
    const no = Calculate.calculate(fields, i, model, tmp[0]);
    const round = Calculate.calculate(fields, i, model, tmp[1]);
    if(typeof no === 'number') {
      return parseFloat(no.toFixed(round));
    } else if(typeof no === 'string') {
      return parseFloat(parseFloat(no).toFixed(round));
    } else {
      return 0;
    }
  }

  static If = (fields, i, model, calculus) => {
    const tmp = Calculate.EuationSeperator(calculus);
    const condition = Calculate.calculate(fields, i, model, tmp[0]);
    return Calculate.calculate(fields, i, model, (condition ? tmp[1] : tmp[2]));
  }

  static GreaterThan = (fields, i, model, calculus) => {
    const tmp = Calculate.EuationSeperator(calculus);
    return Calculate.calculate(fields, i, model, tmp[0]) > Calculate.calculate(fields, i, model, tmp[1]);
  }

  static EuationSeperator = calculus => {
    const tmp = [];
    let lastIndex = 0;
    let index = 0;
    let count = 0;
    while(index < calculus.length) {
      if(calculus.charAt(index) === ',' && count === 0) {
        tmp.push(calculus.substring(lastIndex, index));
        lastIndex = index + 1;
      } else if(calculus.charAt(index) === '(') {
        count++;
      } else if(calculus.charAt(index) === ')') {
        count--;
      }
      index++;
    }
    tmp.push(calculus.substring(lastIndex, index));
    return tmp;
  }
}

export default Calculate;